import { Checkbox } from '~/components/atomic';
import * as S from './Agreement.styled';

interface CheckList {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: JSX.Element;
}

export default function CheckList({ id, checked, onChange, label }: CheckList) {
  return (
    <S.CheckList>
      <S.CheckBox>
        <Checkbox
          id={id}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          colorType={'blue'}
        />
      </S.CheckBox>
      <S.Terms htmlFor={id}>{label}</S.Terms>
    </S.CheckList>
  );
}
